import { z } from "zod";

export const samlValidationRequestSchema = z.object({
	payload: z.string().min(1),
});

const samlClaimsSchema = z.object({
	name: z.string().nullable(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	primarySite: z.string().nullable(),
	additionalSites: z.array(z.string()),
	providedRoles: z.array(z.string()),
});

const samlValidationErrorSchema = z.object({
	code: z.string(),
	message: z.string(),
	correlationId: z.string(),
	fields: z.array(
		z.object({
			field: z.string(),
			expected: z.string(),
			received: z.string().nullable(),
			issue: z.string(),
		}),
	),
});

export const samlValidationResultSchema = z.discriminatedUnion("success", [
	z.object({
		success: z.literal(true),
		error: z.null(),
		claims: samlClaimsSchema,
	}),
	z.object({
		success: z.literal(false),
		error: samlValidationErrorSchema,
		claims: samlClaimsSchema.nullable(),
	}),
]);

export type SamlValidationResult = z.infer<typeof samlValidationResultSchema>;
